import { useMutation } from '@tanstack/react-query'
import { AdminImposedCheckIn } from '..'

const usePostAdminImposedCheckIn = () =>
  useMutation({
    mutationFn: AdminImposedCheckIn,
  })

export default usePostAdminImposedCheckIn
